(function($) {

    $(".footer-accreditations").slick({
        speed: 6000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        rows: 0
    });



    $.fn.hasAnyOfClasses = function(){
        var $self = $(this);
        for(var i= 0, il=arguments.length; i<il; i++){
            if($self.hasClass(arguments[i])) return true;
        }
        return false;
    }

    $("p, h1, h2, h3, h4, h5, h6, .fade-in-text, li:not(.menu-item), tr ").each(function () {
        if(!$(this).hasAnyOfClasses("no-animate", "menu-item")) {
            $(this).attr("data-aos", "fade-up");
        }
    })

    $(window).load(function() {
        setTimeout(function() {
            AOS.refresh();
        }, 500);
    });

    $(window).on('scroll', function() {
        $(".add-anim").each(function() {
            if (isScrolledIntoView($(this))) {
                $anim = $(this).data("animation_name");
                $(this).attr('transition-style', $anim);
                $(this).css("opacity", 1);
            }
        });
    });

    function isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();

        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }




    $.fn.simpleTicker = function(options) {
        // Default settings
        var settings = $.extend({
            interval: 5000, // Time between switches in milliseconds
            speed: 600 // Animation speed in milliseconds
        }, options);

        return this.each(function() {
            var $this = $(this);
            var $items = $this.children('.ticker-item');
            var currentIndex = 0;

            // Initialize ticker
            $items.hide();
            $items.eq(currentIndex).show();

            // Function to show next item
            function showNextItem() {
                $items.eq(currentIndex).fadeOut(settings.speed, function() {
                    currentIndex = (currentIndex + 1) % $items.length;
                    $items.eq(currentIndex).fadeIn(settings.speed);
                });
            }

            // Set interval for the ticker
            setInterval(showNextItem, settings.interval);
        });
    };
    $.fn.simpleMarquee = function(options) {
        // Default settings
        var settings = $.extend({
            speed: 50 // Scrolling speed (higher is slower)
        }, options);

        return this.each(function() {
            var $this = $(this);
            var $items = $this.children('.ticker-item');
            var totalWidth = 0;

            // Wrap items inside a marquee container
            var $marqueeContent = $('<div>').addClass('marquee-content').appendTo($this);
            $items.appendTo($marqueeContent);

            // Calculate total width of all items combined
            $items.each(function() {
                totalWidth += $(this).outerWidth(true);
            });

            // Duplicate content to ensure continuous loop
            $marqueeContent.append($items.clone());

            // Set marquee content width to accommodate both sets of items
            $marqueeContent.width(totalWidth * 2);

            // Animate the scrolling effect without gaps
            function animateMarquee() {
                $marqueeContent.css('left', 0); // Ensure it starts from the beginning
                $marqueeContent.animate({ left: -totalWidth }, totalWidth * settings.speed, 'linear', function() {
                    animateMarquee(); // Continuously loop the animation
                });
            }

            // Start the animation
            animateMarquee();
        });
    };


    $(document).ready(function() {
        // $('.hero-messages').simpleTicker({
        //     interval: 7000, // Set interval to 7 seconds
        //     speed: 800 // Set fade speed to 800ms
        // });

        let duration = $(".hero-messages .ticker-item").length * 12000;

        if(duration > 76000) {
            duration = 76000;
        }

        $('.hero-messages').marquee({
            easing:' linear',
            delayBeforeStart: 2000,
            direction: 'left',
            duplicated: true,
            duration: duration,
            gap: 0,
            pauseOnCycle: false,
            pauseOnHover: true,
            startVisible: true
        });

    });



})( jQuery );


AOS.init({
    once: true,
    duration: 400,
});


var docWidth = document.documentElement.offsetWidth;
[].forEach.call(
    document.querySelectorAll('*'),
    function(el) {
        if (el.offsetWidth > docWidth) {
            console.log(el);
        }
    }
);




